import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "border-b border-black-300 py-16 last:border-b-0" }
const _hoisted_2 = { class: "flex w-full items-center pb-16" }
const _hoisted_3 = { class: "mr-16" }
const _hoisted_4 = { class: "flex flex-1 flex-col" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "text-14 font-medium" }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "ml-auto mt-12 flex items-center" }
const _hoisted_9 = {
  key: 0,
  class: "self-end pr-4 text-12 text-black-400"
}
const _hoisted_10 = { name: "add" }
const _hoisted_11 = ["value"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_image = _resolveComponent("v-image")
  const _component_cart_qty_picker = _resolveComponent("cart-qty-picker")
  const _component_v_icon = _resolveComponent("v-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_image, {
          lazyloaded: "",
          source: $props.item.image,
          class: "h-[6.375rem] w-[4.815rem] object-cover"
        }, null, 8, ["source"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (!$props.item.gift_card)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              ($props.item.properties?.[$data.locale.deliverable_at])
                ? (_openBlock(), _createElementBlock("small", {
                    key: 0,
                    class: "mb-4 text-[0.6875rem] tracking-wide",
                    style: _normalizeStyle(`color: ${$data.unavailableProductColor}`)
                  }, _toDisplayString($data.locale.deliverable_at) + " " + _toDisplayString($props.item.properties?.[$data.locale.deliverable_at]), 5))
                : (_openBlock(), _createElementBlock("small", {
                    key: 1,
                    class: "mb-4 text-[0.6875rem] tracking-wide",
                    style: _normalizeStyle(`color: ${$data.availableProductColor}`)
                  }, _toDisplayString($data.locale.available_now), 5))
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("a", {
          href: $props.item.url
        }, [
          _createElementVNode("span", _hoisted_6, _toDisplayString($props.item.product_title), 1)
        ], 8, _hoisted_5),
        (!$props.item.properties['_FreeGift'])
          ? (_openBlock(), _createBlock(_component_cart_qty_picker, {
              key: $props.item.quantity,
              product: $props.item,
              onIsClicked: $options.toggleSkeleton
            }, null, 8, ["product", "onIsClicked"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, "Free gift")),
        _createElementVNode("div", _hoisted_8, [
          ($options.compareAtPrice > $options.price)
            ? (_openBlock(), _createElementBlock("del", _hoisted_9, _toDisplayString($options.formattedCompareAtPrice), 1))
            : _createCommentVNode("", true),
          _createElementVNode("span", {
            class: _normalizeClass(["mr-8 text-14 font-medium", $data.skeletonClass])
          }, _toDisplayString($options.formattedPrice), 3),
          _createElementVNode("form", {
            class: "h-22",
            onSubmit: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.debouncedDelete($event)), ["prevent"]))
          }, [
            _createElementVNode("button", _hoisted_10, [
              _createVNode(_component_v_icon, {
                icon: "trash",
                width: 18,
                height: 18,
                color: "#605F5F"
              })
            ]),
            _createElementVNode("input", {
              type: "hidden",
              name: "id",
              value: $props.item.key
            }, null, 8, _hoisted_11),
            _cache[1] || (_cache[1] = _createElementVNode("input", {
              type: "hidden",
              name: "quantity",
              value: 0
            }, null, -1))
          ], 32)
        ])
      ])
    ])
  ]))
}